import { trackVideoStart } from '@/js/lib/analytics';

const ROOT_SELECTOR = '.js-cta-video';
const PLAY_SELECTOR = '.js-cta-video-play';
const IFRAME_SELECTOR = 'iframe';

function resolveProvider(src: string): string {
  try {
    const { hostname } = new URL(src, window.location.origin);

    if (hostname.includes('youtube') || hostname.includes('youtu.be')) {
      return 'youtube';
    }

    if (hostname.includes('vimeo')) {
      return 'vimeo';
    }

    return hostname;
  }
  catch {
    return 'unknown';
  }
}

/** Drops the query so autoplay/start-time variants do not split one video into many rows. */
function stripQuery(src: string): string {
  try {
    const url = new URL(src, window.location.origin);

    return `${url.origin}${url.pathname}`;
  }
  catch {
    return src;
  }
}

function bindCtaVideo(root: HTMLElement): void {
  const button = root.querySelector<HTMLButtonElement>(PLAY_SELECTOR);
  const iframe = root.querySelector<HTMLIFrameElement>(IFRAME_SELECTOR);
  const src = iframe?.dataset.src;

  if (!button || !iframe || !src) {
    return;
  }

  button.addEventListener(
    'click',
    () => {
      iframe.src = src;
      root.classList.add('is-playing');

      trackVideoStart({
        provider: resolveProvider(src),
        title: root.dataset.analyticsVideoTitle ?? '',
        url: stripQuery(src),
      });
    },
    { once: true },
  );
}

export function initCtaVideo(): void {
  const roots = document.querySelectorAll<HTMLElement>(ROOT_SELECTOR);

  for (const root of roots) {
    bindCtaVideo(root);
  }
}
